import React from 'react';

export default function CustomerInfo({ formData, setFormData }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-xl font-semibold text-cyan-500 mb-6">
          Customer Information
        </h2>
        <p className="text-gray-400 mb-8">
          Please provide your contact details so we can keep you updated about your order. Payment will be collected after we receive your information and send you a quote.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2">
        <div className="bg-gray-800 p-4 rounded-lg">
          <label htmlFor="name" className="block text-sm font-medium text-gray-300">
            Name *
          </label>
          <input
            type="text"
            name="name"
            id="name"
            required
            value={formData.name}
            onChange={handleChange}
            className="mt-2 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-cyan-500 focus:ring-cyan-500 px-3 py-2"
          />
        </div>

        <div className="bg-gray-800 p-4 rounded-lg">
          <label htmlFor="email" className="block text-sm font-medium text-gray-300">
            Email *
          </label>
          <input
            type="email"
            name="email"
            id="email"
            required
            value={formData.email}
            onChange={handleChange}
            className="mt-2 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-cyan-500 focus:ring-cyan-500 px-3 py-2"
          />
        </div>

        <div className="bg-gray-800 p-4 rounded-lg">
          <label htmlFor="company" className="block text-sm font-medium text-gray-300">
            Company Name
          </label>
          <input
            type="text"
            name="company"
            id="company"
            value={formData.company}
            onChange={handleChange}
            className="mt-2 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-cyan-500 focus:ring-cyan-500 px-3 py-2"
          />
        </div>

        <div className="bg-gray-800 p-4 rounded-lg">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-300">
            Phone Number
          </label>
          <input
            type="tel"
            name="phone"
            id="phone"
            value={formData.phone}
            onChange={handleChange}
            className="mt-2 block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-cyan-500 focus:ring-cyan-500 px-3 py-2"
          />
        </div>
      </div>
    </div>
  );
}